// Normalize date string to YYYY-MM-DD format
// Handles: extra spaces, single-digit months/days without leading zeros
export function normalizeDate(dateStr: string): string {
  // Remove all whitespace
  const cleaned = dateStr.replace(/\s+/g, "");

  // Parse the date parts
  const parts = cleaned.split("-");
  if (parts.length !== 3) return cleaned;

  const [year, month, day] = parts;

  // Pad month and day with leading zeros if needed
  const paddedMonth = month.padStart(2, "0");
  const paddedDay = day.padStart(2, "0");

  return `${year}-${paddedMonth}-${paddedDay}`;
}

